<textarea
  name="{{prefix}}[{{name}}]"
  id="{{id}}"
  {{#if testIdPrefix}}data-testid="{{testIdPrefix}}-{{dasherize name}}"{{/if}}
  {{#if required}}required{{/if}}
  {{#if disabled}}disabled{{/if}}
  {{#if placeholder }} placeholder="{{placeholder}}" {{/if}}
  {{#if max_length }} maxlength="{{limit_size}}" {{/if}}
>{{value}}</textarea>
